import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

import TMXSelect from 'components/selectors/tmxSelector/TMXSelect';
import { SelectItemLabel } from 'components/typography/Typography';
import { NO_SELECTION } from 'constants/generic';

export const GenderSelector = (props) => {
  const { options, selectedGender, selectGender } = props || { options: [] };
  const { t } = useTranslation();

  return (
    <TMXSelect value={selectedGender} onChange={selectGender}>
      <MenuItem value={NO_SELECTION}>
        <SelectItemLabel>{t('anyGender')}</SelectItemLabel>
      </MenuItem>
      {options.map((t) => (
        <MenuItem key={t.value} value={t.value}>
          <SelectItemLabel>{t.text}</SelectItemLabel>
        </MenuItem>
      ))}
    </TMXSelect>
  );
};
